/**
 * Retrieves the value from a nested object using a dot-separated path.
 *
 * @param {Object} obj - The object from which to retrieve the value.
 * @param {string} path - The dot-separated path specifying the location of the value within the object.
 * @returns {*} The value located at the specified path, or undefined if the path does not exist.
 */
export function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj)
}
